import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { b2bList } from "@/data/b2b";

const Footer = () => {
  return (
    <footer className="bg-zinc-950 text-zinc-300 border-t-2 border-[#D9480F]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-14 h-14 bg-white border-2 border-white overflow-hidden">
                <img
                  src="https://customer-assets.emergentagent.com/job_site-builder-3572/artifacts/int9cqaw_FE1D1B5F-B5C0-402C-A181-71BFC9E298FA.png"
                  alt="Blue Collar World Pest Control logo"
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <div className="font-display uppercase text-lg tracking-tight text-white">
                  Blue Collar World
                </div>
                <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-zinc-500">
                  Pest Control · LLC
                </div>
              </div>
            </div>
            <p className="text-sm leading-relaxed max-w-sm">
              Licensed and insured pest control for Pittsburgh households, parks and schools.
              Specialists in wood-destroying insects, wildlife, mosquitoes and bed bugs.
              Se habla español.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#F59E0B] font-bold mb-4">
              Services
            </h4>
            <ul className="space-y-2 text-sm">
              <li>Households</li>
              <li>Parks & Schools</li>
              <li>Termites & Wood Pests</li>
              <li>Wildlife Removal</li>
              <li>Mosquito Control</li>
              <li>Bed Bug Treatment</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#F59E0B] font-bold mb-4">
              For Business
            </h4>
            <ul className="space-y-2 text-sm">
              {b2bList.map((b) => (
                <li key={b.slug}>
                  <Link to={`/for/${b.slug}`} className="hover:text-white">
                    {b.label.replace("For ", "")}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#F59E0B] font-bold mb-4">
              Contact
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-[#D9480F]" strokeWidth={2.5} />
                <div>
                  <a href="tel:4847643392" className="hover:text-white block">484-764-3392</a>
                  <span className="text-[10px] uppercase tracking-[0.18em] font-mono text-zinc-500">Owner</span>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-[#D9480F]" strokeWidth={2.5} />
                <div>
                  <a href="tel:4124514358" className="hover:text-white block">412-451-4358</a>
                  <span className="text-[10px] uppercase tracking-[0.18em] font-mono text-zinc-500">Bryan Batanoff · Service Mgr</span>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-[#D9480F]" strokeWidth={2.5} />
                <a href="mailto:raymondtjackson@bluecollarworldpestcontrolservices.com" className="hover:text-white break-all">
                  raymondtjackson@bluecollarworldpestcontrolservices.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-[#D9480F]" strokeWidth={2.5} />
                <span>904 Bernd Street, Pittsburgh PA 15210</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-800 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500">
            © {new Date().getFullYear()} Blue Collar World LLC · All Rights Reserved
          </p>
          <div className="flex items-center gap-6 font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500 flex-wrap">
            <span className="text-[#F59E0B]">★ PA License #BU15680</span>
            <span>Licensed & Insured</span>
            <span>Se Habla Español</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
